/**
 * Find proximity session restart guard — coalesce churn without delaying intentional group switches.
 */
export const FIND_SESSION_GUARD = {
  /** Minimum time a session stays up before a churn-driven restart is allowed. */
  minLifetimeMs: 8_000,
  /** Collapse rapid sessionRunKey changes into one restart. */
  debounceMs: 500,
  /** Ignore duplicate picker arms for the same group within this window. */
  pickerArmCollapseMs: 5_000,
};

/*
 * navGraceMs is gone. It held GPS and the realtime subscription for 120 s after leaving
 * Find and then tore the session down, which meant being findable required standing on
 * the Find page. The session now runs app-wide for as long as a group is selected and
 * only BLE pauses off the page — see pauseRadiosOffFind in useProximity.
 */

/** Armed by a single committed picker selection — consumed once when session run starts. */
let armedUserGroupSelection = null;
let armedAtMs = 0;

export function armUserGroupSelection(groupId) {
  if (!groupId) {
    return false;
  }
  const now = Date.now();
  if (
    armedUserGroupSelection === groupId &&
    now - armedAtMs < FIND_SESSION_GUARD.pickerArmCollapseMs
  ) {
    return false;
  }
  armedUserGroupSelection = groupId;
  armedAtMs = now;
  return true;
}

export function hasUserGroupSelectionArm(groupId) {
  return armedUserGroupSelection === groupId;
}

/** One-shot consume — only call from proximity session run(). */
export function consumeUserGroupSelectionArm(groupId) {
  if (armedUserGroupSelection === groupId) {
    armedUserGroupSelection = null;
    return true;
  }
  return false;
}

export function clearUserGroupSelectionArm() {
  armedUserGroupSelection = null;
  armedAtMs = 0;
}
